import { hapticFeedback } from '@telegram-apps/sdk-react';

export const haptic = {
  success: () => safe(() => hapticFeedback.notificationOccurred('success')),
  error: () => safe(() => hapticFeedback.notificationOccurred('error')),
  tap: () => safe(() => hapticFeedback.impactOccurred('light')),
  select: () => safe(() => hapticFeedback.selectionChanged()),
};

function safe(fn: () => void): void {
  try {
    fn();
  } catch {
    /* вне Telegram или не поддерживается */
  }
}
